// ignore-string-externalization

import React from 'react';
import { marked } from 'marked';
import getCookies from 'next-cookies';
import { NextPageContext } from 'next';

export const youtubeIdRegex =
  /^https:\/\/(?:www\.youtube\.com\/watch\?v=|youtu\.be\/)([^/&\s]+)/i;

// super-simple markdown formatter, mostly just line breaks, bold and italics
export function formatText(str?: string | null) {
  return marked.parseInline((str || '').trim().replace(/(\\n|\n)/g, '<br />'), {
    xhtml: true,
    smartypants: true,
  });
}

// fix common mistakes in href's entered from contentful
export function fixHref(val?: string) {
  if (val === null || val === undefined) {
    return val;
  }

  let href = val
    .trim()
    .replace(/^((https|http):)?(\/\/)?artists\.spotify\.com/, '');
  if (href === '') href = '/'; // empty url probably refers to root, esp after ^^^
  return href;
}

export const getTallest = (
  refCollection: Array<React.MutableRefObject<Element | undefined>>,
) => {
  let tallestRef = 0;
  refCollection.forEach((ref: React.MutableRefObject<Element | undefined>) => {
    if (ref.current) {
      ref.current.classList.remove('tallest');
      const thisRefHeight = ref.current.getBoundingClientRect().height;
      if (thisRefHeight > tallestRef) {
        tallestRef = thisRefHeight;
      }
    }
  });
  return tallestRef;
};

export const setTallestClass = (
  refCollection: Array<React.MutableRefObject<Element | undefined>>,
) => {
  refCollection.forEach((ref: React.MutableRefObject<Element | undefined>) => {
    if (ref.current) {
      ref.current.classList.add('tallest');
    }
  });
};

export function isPreview(context: NextPageContext) {
  const cookies = getCookies(context);
  return Boolean(cookies.__prerender_bypass && cookies.__next_preview_data);
}

export const getAuthorDateString = (author: string, releaseDate: string) => {
  if (author && releaseDate && releaseDate !== 'Invalid Date') {
    return `${author} \/ ${releaseDate}`;
  } else if (author) {
    return author;
  } else if (releaseDate !== 'Invalid Date') {
    return releaseDate;
  }
  return '';
};

export const transformScaleUp = `transform: scale(1.05);`;

export function isContentfulImage(url: string) {
  return (
    url &&
    (url.includes('images.ctfassets.net') ||
      url.includes('images.contentful.com'))
  );
}

export const isValidPath = (url: string | null | undefined): boolean => {
  if (url) {
    const decoded = decodeURIComponent(url);
    return (
      !decoded.includes('\\') &&
      !decoded.match(/^\/\//) &&
      !decoded.match(/^.+:.+/)
    );
  }

  return false;
};
